import { useId } from "react";
import { MdCloudUpload } from "react-icons/md";
import notify from "lib/notify";

const ACCEPTED_TYPES = ["image/jpeg", "image/png", "image/gif"];

const ImageUploader = ({ imagePreview, setImagePreview, setImageFile }) => {
  const inputId = useId();

  const handleImageChange = (event) => {
    const file = event.target.files?.[0];
    if (!file) return;

    if (!ACCEPTED_TYPES.includes(file.type)) {
      notify.error("Only JPG, PNG and GIF files are allowed.");
      event.target.value = "";
      return;
    }

    const reader = new FileReader();
    reader.onloadend = () => {
      setImagePreview(reader.result);
    };
    reader.readAsDataURL(file);
    setImageFile(file);
  };

  return (
    <div className="space-y-3 rounded-card border border-dashed border-line bg-surface-raised p-6 text-center">
      {imagePreview ? (
        <img
          src={imagePreview}
          alt="Household preview"
          className="mx-auto max-h-60 rounded-control object-contain"
        />
      ) : (
        <>
          <MdCloudUpload aria-hidden="true" className="mx-auto h-10 w-10 text-fg-muted" />
          <p className="text-sm font-semibold text-fg">Image Requirements</p>
          <p className="text-sm text-fg-muted">
            GIF, JPG or PNG, up to 5600 x 5600 px and 50MB.
          </p>
        </>
      )}

      <label
        htmlFor={inputId}
        className="inline-flex h-8 cursor-pointer items-center rounded-control border border-line bg-surface px-3 text-xs font-medium text-fg transition-colors hover:bg-surface-subtle focus-within:ring-2 focus-within:ring-focus"
      >
        {imagePreview ? "Replace Image" : "Browse"}
        <input
          id={inputId}
          type="file"
          accept="image/png, image/jpeg, image/gif"
          onChange={handleImageChange}
          className="sr-only"
        />
      </label>
    </div>
  );
};

export default ImageUploader;
